module.exports = __webpack_public_path__ + "static/media/Jawbreak-Sans.42de4ad1.otf";